export const INIT_AUTH = 'INIT_AUTH'

export const GET_DASHBOARD_DATA = 'GET_DASHBOARD_DATA'
export const GET_CREW_DATA = 'GET_CREW_DATA'
export const GET_CREW_MANAGEMENT_APPLICATIONS =
  'GET_CREW_MANAGEMENT_APPLICATIONS'
export const GET_VISITORS_DATA = 'GET_VISITORS_DATA'
export const GET_VISITOR_BY_ID = 'GET_VISITOR_BY_ID'
export const GET_VISITORS_IMPORT_STATUS = 'GET_VISITORS_IMPORT_STATUS'
export const GET_VISITOR_RULES = 'GET_VISITOR_RULES'
export const GET_GUESTS_DATA = 'GET_GUESTS_DATA'
export const GET_INCLUDE_RESERVATION_GUESTS_DATA =
  'GET_INCLUDE_RESERVATION_GUESTS_DATA'
export const GET_GUEST_EXCEPTION = 'GET_GUEST_EXCEPTION'
export const ADD_GUEST_INFORMATION = 'ADD_GUEST_INFORMATION'
export const GET_HISTORY = 'GET_HISTORY'
export const SHOW_MINOR_ERROR = 'SHOW_MINOR_ERROR'
export const GET_CABINS_DATA = 'GET_CABINS_DATA'
export const PAST_VOYAGE_LIST = 'PAST_VOYAGE_LIST'
export const GET_SETTINGS_DATA = 'GET_SETTINGS_DATA'
export const GET_VOYAGE_DATA = 'GET_VOYAGE_DATA'
export const IS_PAST_VOYAGE = 'IS_PAST_VOYAGE'
export const GET_CURRENT_SHIP = 'GET_CURRENT_SHIP'
export const SET_MODE = 'SET_MODE'
export const GET_RESERVATION_LIST = 'GET_RESERVATION_LIST'
export const GET_HISTORY_ATTRIBUTE = 'GET_HISTORY_ATTRIBUTE'

export const GET_STARTUP_DATA = 'GET_STARTUP_DATA'
export const POST_STATEROOM_DATA = 'POST_STATEROOM_DATA'
export const GET_MASTER_DATA = 'GET_MASTER_DATA'

export const GET_PERSON_DETAILS = 'GET_PERSON_DETAILS'

export const GET_GUEST_TYPE = 'GET_GUEST_TYPE'

export const SET_GUEST_INFO = 'SET_GUEST_INFO'
export const GET_SHIPS_DATA = 'GET_SHIPS_DATA'

export const GET_ALERTS = 'GET_ALERTS'
export const GET_MESSAGES = 'GET_MESSAGES'
export const GET_ALERT = 'GET_ALERT'
export const GET_MESSAGE = 'GET_MESSAGE'

export const POST_RESERVATION_DATA = 'POST_RESERVATION_DATA'

export const GET_PERSONS = 'GET_PERSONS'
export const GET_STATEROOM_CATEGORY = 'GET_STATEROOM_CATEGORY'
export const GET_STATEROOM_CAPACITY = 'GET_STATEROOM_CAPACITY'

export const POST_STATEROOM_STATUS = 'POST_STATEROOM_STATUS'

export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION'
export const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION'
export const GET_MASTER_BOARDING_DATA = 'GET_MASTER_BOARDING_DATA'
export const GET_DEFAULT_MASTER_DATA = 'GET_DEFAULT_MASTER_DATA'

export const SHOW_LOADER = 'SHOW_LOADER'
export const HIDE_LOADER = 'HIDE_LOADER'

export const GET_IPM_DATA = 'GET_IPM_DATA'
export const GET_IPM_GROUP_DATA = 'GET_IPM_GROUP_DATA'

export const GET_IPM_DASHBOARD_DATA = 'GET_IPM_DASHBOARD_DATA'

export const GET_SEARCH_DATA = 'GET_SEARCH_DATA'
export const GET_SEARCH_GUEST_DATA = 'GET_SEARCH_GUEST_DATA'
export const GET_OCCUPIED_LIST = 'GET_OCCUPIED_LIST'
export const GET_GLOBAL_SEARCH_ROLES = 'GET_GLOBAL_SEARCH_ROLES'

export const GET_SLOTS_DATA = 'GET_SLOTS_DATA'
export const GET_BOARDING_PATTERN_DATA = 'GET_BOARDING_PATTERN_DATA'
export const POST_SLOTS_DATA = 'POST_SLOTS_DATA'
export const GET_GUEST_COUNT = 'GET_GUEST_COUNT'
export const PATCH_SLOTS_DATA = 'PATCH_SLOTS_DATA'

export const GET_RESOURCES = 'GET_RESOURCES'

export const GET_MOVEMENT_REPORTS = 'GET_MOVEMENT_REPORTS'
export const GET_MISSING_PICTURE_REPORTS = 'GET_MISSING_PICTURE_REPORTS'
export const GET_EXPIRED_CARD_REPORTS = 'GET_EXPIRED_CARD_REPORTS'
export const GET_NOT_CHECKEDIN_ONBOARD_REPORTS =
  'GET_NOT_CHECKEDIN_ONBOARD_REPORTS'
export const GET_CHECKEDIN_NOT_ONBOARD_REPORTS =
  'GET_CHECKEDIN_NOT_ONBOARD_REPORTS'
export const GET_RESERVATIONS_MISSING_IN_FIDELIO_REPORTS =
  'GET_RESERVATIONS_MISSING_IN_FIDELIO_REPORTS'
export const GET_VISITOR_ONBOARD_REPORTS = 'GET_VISITOR_ONBOARD_REPORTS'
export const GET_WEARABLE_ASSIGNED_REPORTS = 'GET_WEARABLE_ASSIGNED_REPORTS'
export const GET_BOARDING_SLOT_REPORTS = 'GET_BOARDING_SLOT_REPORTS'
export const GET_DEBARKED_ONBOARDED_SUMMARY_REPORTS =
  'GET_DEBARKED_ONBOARDED_SUMMARY_REPORTS'
export const GET_CREW_HISTORY_LOCATION_REPORTS =
  'GET_CREW_HISTORY_LOCATION_REPORTS'
export const GET_VISITOR_HISTORY_LOCATION_REPORTS =
  'GET_VISITOR_HISTORY_LOCATION_REPORTS'
export const GET_SAILOR_HISTORY_LOCATION_REPORTS =
  'GET_SAILOR_HISTORY_LOCATION_REPORTS'
export const GET_ALERTS_REPORTS = 'GET_ALERTS_REPORTS'

export const GET_LOCATION_REPORTS = 'GET_LOCATION_REPORTS'
export const GET_CBP_REPORTS_GUESTS = 'GET_CBP_REPORTS_GUESTS'
export const GET_CBP_REPORTS_CREW = 'GET_CBP_REPORTS_CREW'
export const GET_IPM_REPORTS = 'GET_IPM_REPORTS'
export const GET_BOARDING_SLOT_HISTORY_REPORTS =
  'GET_BOARDING_SLOT_HISTORY_REPORTS'
export const GET_INACTIVE_VISITOR_REPORTS = 'GET_INACTIVE_VISITOR_REPORTS'
export const GET_SAILOR_FLIGHT_DETAILS_REPORTS =
  'GET_SAILOR_FLIGHT_DETAILS_REPORTS'
export const GET_DOCUMENT_TYPE_BREAKDOWN_REPORTS =
  'GET_DOCUMENT_TYPE_BREAKDOWN_REPORTS'
export const GET_DOCUMENT_WISE_SAILORS = 'GET_DOCUMENT_WISE_SAILORS'
export const GET_SAILOR_NATIONALITY_REPORTS = 'GET_SAILOR_NATIONALITY_REPORTS'
export const GET_NATIONALITY_WISE_SAILORS = 'GET_NATIONALITY_WISE_SAILORS'

export const SEARCH_SAILOR_ASHORE_VISITS_REQUEST =
  'SEARCH_SAILOR_ASHORE_VISITS_REQUEST'
export const SEARCH_SAILOR_ASHORE_VISITS_SUCCESS =
  'SEARCH_SAILOR_ASHORE_VISITS_SUCCESS'
export const SEARCH_SAILOR_ASHORE_VISITS_FAILURE =
  'SEARCH_SAILOR_ASHORE_VISITS_FAILURE'
export const CLEAR_SAILOR_ASHORE_VISITS = 'CLEAR_SAILOR_ASHORE_VISITS'

export const GET_BROADCAST_MESSAGES = 'GET_BROADCAST_MESSAGES'
export const UPDATE_BROADCAST_MESSAGES = 'UPDATE_BROADCAST_MESSAGES'
export const POST_STATEROOM_SEARCH_DATA = 'POST_STATEROOM_SEARCH_DATA'
export const POST_STATEROOM_FILTER_DATA = 'POST_STATEROOM_FILTER_DATA'

export const GET_STATEROOM_GUESTS_DATA = 'GET_STATEROOM_GUESTS_DATA'
export const GET_RESERVATION_GUESTS = 'GET_RESERVATION_GUESTS'
export const GET_RESERVATION_PARTY = 'GET_RESERVATION_PARTY'
export const GET_STATEROOM_PARTY = 'GET_STATEROOM_PARTY'
export const GET_VOYAGE_WITH = 'GET_VOYAGE_WITH'
export const GET_TRAVEL_PARTY = 'GET_TRAVEL_PARTY'
export const GET_STATEROOM_GUESTS_LIST = 'GET_STATEROOM_GUESTS_LIST'
export const GET_VIP_ICONS_DATA = 'GET_VIP_ICONS_DATA'
export const GET_PORT_TERMINALS = 'GET_PORT_TERMINALS'
export const GET_VOYAGE_PORT_TERMINALS = 'GET_VOYAGE_PORT_TERMINALS'
export const GENERATE_ENOAD_BATCH_MSG = 'GENERATE_ENOAD_BATCH_MSG'
export const GENERATED_ENOAD_BATCH_COMPARISON_RESULT =
  'GENERATED_ENOAD_BATCH_COMPARISON_RESULT'
export const EXISTING_ENOAD_BATCH_COMPARISON_RESULT =
  'EXISTING_ENOAD_BATCH_COMPARISON_RESULT'
export const GET_LEGS_LIST = 'GET_LEGS_LIST'
export const SELECTED_PORT = 'SELECTED_PORT'
